import IsPerformanceResourceSupported from './IsPerformanceResourceSupported';

/**
 * Creates a performance marker with the given measureName.
 * @param name - marker key.
 */
export default function safePerformanceMark(name: string): void {
    if (IsPerformanceResourceSupported) {
        performance?.mark?.(name);
    }
}
